import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "events-page container py-4" };
const _hoisted_2 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_3 = {
    key: 1,
    class: "error-state"
};
const _hoisted_4 = { key: 2 };
const _hoisted_5 = {
    key: 3,
    class: "empty-state"
};
import { ref, onMounted, watch, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import EventsHero from '@/components/events/EventsHero.vue';
import EventsHeader from '@/components/events/EventsHeader.vue';
import EventsDetails from '@/components/events/EventsDetails.vue';
import EventsMap from '@/components/events/EventsMap.vue';
import EventsNearbyCarousel from '@/components/events/EventsNearbyCarousel.vue';
import { eventsService } from '@/services/eventsService';
// Props para recibir el ID del evento desde la ruta
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventsPage',
    props: {
        id: {}
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        const app = getCurrentInstance();
        const currentEvent = ref(null);
        const loading = ref(false);
        const error = ref(null);
        // Función para obtener el ID del evento (desde props o route params)
        const getEventId = () => {
            return props.id || route.params.id;
        };
        // Función para cargar el evento específico
        const getMainImage = (event) => {
            const buildImg = app?.appContext?.config?.globalProperties?.$buildImg;
            const mainImage = event.images?.find((img) => img.is_main) || event.images?.[0];
            if (mainImage?.image_url) {
                return buildImg ? buildImg(mainImage.image_url) : mainImage.image_url;
            }
            return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT72hubnZuZFDGuaP7KhaWTjtgCpZ3DZwoZ5w&s';
        };
        const fetchEvent = async () => {
            const eventId = getEventId();
            if (!eventId) {
                error.value = 'ID de evento no proporcionado';
                return;
            }
            loading.value = true;
            error.value = null;
            try {
                const response = await eventsService.getEventById(eventId);
                if (response.success && response.data) {
                    currentEvent.value = response.data;
                }
                else {
                    throw new Error('Evento no encontrado');
                }
            }
            catch (err) {
                console.error('Error fetching event:', err);
                error.value = 'Error al cargar el evento';
                currentEvent.value = null;
            }
            finally {
                loading.value = false;
            }
        };
        // Cargar evento al montar el componente
        onMounted(() => {
            fetchEvent();
        });
        // Observar cambios en el ID del evento
        watch(() => getEventId(), () => {
            fetchEvent();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
                        _createElementVNode("div", { class: "spinner" }, null, -1),
                        _createElementVNode("p", null, "Cargando evento...", -1)
                    ])))
                    : (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                            _createElementVNode("p", null, _toDisplayString(error.value), 1),
                            _createElementVNode("button", {
                                onClick: fetchEvent,
                                class: "retry-btn"
                            }, "Reintentar")
                        ]))
                        : (currentEvent.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(EventsHero, {
                                    featured: {
                                        ...currentEvent.value,
                                        regionImage: getMainImage(currentEvent.value)
                                    }
                                }, null, 8, ["featured"]),
                                _createVNode(EventsHeader, {
                                    title: currentEvent.value.name,
                                    subtitle: currentEvent.value.description
                                }, null, 8, ["title", "subtitle"]),
                                _createVNode(EventsDetails, { event: currentEvent.value }, null, 8, ["event"]),
                                _createVNode(EventsMap, { event: currentEvent.value }, null, 8, ["event"]),
                                _createVNode(EventsNearbyCarousel, {
                                    excludeEventId: currentEvent.value.id
                                }, null, 8, ["excludeEventId"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "fas fa-calendar-times" }, null, -1),
                                _createElementVNode("p", null, "Evento no encontrado", -1)
                            ])))
            ]));
        };
    }
});
